module.exports = __webpack_public_path__ + "portal-static/img/achievement.788a9259.png";